export default __webpack_public_path__ + "static/media/logo-gaaf.ececaba2.webp";